import React from 'react';
import PropTypes from 'prop-types';
import { Common } from 'ws-scripts/modules/common';

import {
	PLUS_TAXES_ASTERISK,
	PLUS_SALES_TAXES_ASTERISK
} from '../constants/labels';

export const CaDisclaimer = ({ dealerAddress, isFooter }) => {
	const CAAlternateDisclaimerProvinces = ['AB', 'BC', 'MB', 'ON', 'QC', 'SK'];
	const staticDisclaimerClasses =
		'final-price-disclaimer ddc-font-size-xsmall text-muted w-100 ';
	const disclaimerClasses =
		staticDisclaimerClasses +
		(isFooter ? 'text-left summary-disclaimer' : 'text-right');
	let disclaimerLabel = PLUS_TAXES_ASTERISK;

	if (CAAlternateDisclaimerProvinces.includes(dealerAddress.state)) {
		disclaimerLabel = PLUS_SALES_TAXES_ASTERISK;
	}

	if (dealerAddress.country === 'CA') {
		return (
			<div className={disclaimerClasses}>
				<Common
					render={({ labels }) => {
						return labels.get(disclaimerLabel);
					}}
				/>
			</div>
		);
	} else {
		return null;
	}
};

CaDisclaimer.propTypes = {
	dealerAddress: PropTypes.shape({
		address1: PropTypes.string,
		address2: PropTypes.string,
		address3: PropTypes.string,
		city: PropTypes.string,
		state: PropTypes.string,
		postalCode: PropTypes.string,
		country: PropTypes.string
	})
};
CaDisclaimer.defaultProps = {
	dealerAddress: {},
	isFooter: false
};
export default CaDisclaimer;



// WEBPACK FOOTER //
// ./src/components/CanadaDisclaimerContent.jsx